import styled from "styled-components";

export const CoverImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  width: 100%;

  img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
`;
